var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs"},[_c('el-form-item',{attrs:{"label":"联系我们：","prop":"contactUs"}},[_c('el-input',{staticClass:"fl",staticStyle:{"width":"50%"},attrs:{"type":"text"},model:{value:(_vm.ruleForm.contactUs),callback:function ($$v) {_vm.$set(_vm.ruleForm, "contactUs", $$v)},expression:"ruleForm.contactUs"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }